<h2 mat-dialog-title class="center-title">Image Data</h2>

<mat-dialog-content class="custom-dialog-content">
  <div class="data-container">
    <p class="left" *ngIf="data.context === 'dataSync'">
      Filepath: {{ data.originalfilepath }}
    </p>
    <p class="left" *ngIf="data.context !== 'dataSync'">Key: {{ data.key }}</p>
    <p class="right">Filename: {{ data.originalfilename }}</p> 
  </div>
</mat-dialog-content>

<mat-dialog-content class="custom-dialog-content">
  <div class="data-container">
    <p class="left" *ngIf="data.context !== 'dataSync'">
      Carline: {{ data.carline }}
    </p>
    <p class="left" *ngIf="data.context === 'dataSync'">
      Plant: {{ data.carline }}
    </p>
    <p class="center">CreationDate: {{ data.creationdate }}</p>
    <p class="right" *ngIf="data.context !== 'dataSync'">
      Workstation: {{ data.workstation }}
    </p>
    <p class="right" *ngIf="data.context === 'dataSync'">
      Station: {{ data.workstation }}
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-content class="custom-dialog-content">
  <div class="data-container" *ngIf="data.context !== 'dataSync'">
    <p class="left">OrderIdent: {{ data.orderident }}</p>
    <p class="right">OrderType: {{ data.ordertype }}</p>
  </div>

  <div class="image-container">
    <img [src]="data.imageData" alt="Image" />
  </div>
</mat-dialog-content>

<mat-dialog-actions class="custom-dialog-actions">
  <button mat-button [mat-dialog-close] cdkFocusInitial class="close-button">
    <i class="fa-regular fa-rectangle-xmark"></i>
    Close
  </button>
</mat-dialog-actions>
